import { render, staticRenderFns } from "./feedbackBlock.vue?vue&type=template&id=1e154bae&"
import script from "./feedbackBlock.vue?vue&type=script&lang=js&"
export * from "./feedbackBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports